import Vue from "vue";
const VBtn = Vue.options.components["VBtn"];

export default {
  extends: VBtn,
  name: "v-btn",
  methdos: {},
  mounted() {
    let isIcon = (elem) => {
      return elem.classList.value.indexOf("v-btn--icon") >= 0 || elem.innerText === "";
    };

    let isTransparent = (elem) => {
      return window.getComputedStyle(elem).backgroundColor === "rgba(0, 0, 0, 0)" && elem.innerText != "";
    };
    let waitForElementBackgound = (elem) => {
      let bgRgb = window.getComputedStyle(elem).backgroundColor.match(/\d+/g);
      let colorRgb = window.getComputedStyle(elem).color.match(/\d+/g);
      let bg = bgRgb
        ? bgRgb.map((c) => {
            return parseInt(c);
          })
        : null;
      let cl = colorRgb
        ? colorRgb.map((c) => {
            return parseInt(c);
          })
        : null;
      if (!bg || (bg && bg.length === 4 && bg[3] === 0 && cl && cl[0] === 0)) {
        if (isIcon(elem)) {
          return Promise.resolve(bg);
        }
        if (isTransparent(elem)) {
          bg = [255, 255, 255];
          return Promise.resolve(bg);
        }

        return waitAsync().then(() => waitForElementBackgound(elem));
      } else {
        return Promise.resolve(bg);
      }
    };
    let waitAsync = () => {
      return new Promise((resolve) => {
        requestAnimationFrame(resolve);
      });
    };
    if (this.$el) {
      waitForElementBackgound(this.$el).then((rgb) => {
        let hsp = Math.sqrt(0.299 * (rgb[0] * rgb[0]) + 0.587 * (rgb[1] * rgb[1]) + 0.114 * (rgb[2] * rgb[2]));
        if (hsp > 127.5) {
          this.$el.style.color = "#363635"; //bright backgound
        } else {
          this.$el.style.color = "#e3e3de";
        }
      });
    }
  },
};
